import { isSegmentAvailable } from './travelers';
export const flatBounds = function (bounds) {
  if (bounds === void 0) {
    bounds = [];
  }
  return bounds.flatMap(segments => segments.sellSeatMapSegments.map(segment => ({
    ...segment,
    boundIndex: segments.boundIndex,
    boundName: segments.boundName,
    boundSegmentId: [segments.boundIndex, segment.boundSegmentIndex],
    isAvailable: isSegmentAvailable(segment)
  })));
};
//# sourceMappingURL=bounds.js.map